import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./config/loadAppStyles";
import "./styles/responsiveOverrides.css";
import "./styles/rtlOverrides.css";
import "./styles/authSplit.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AppPortalHost from "./components/Portal/AppPortalHost";
import ErrorBoundary from "./ErrorBoundary";
import { LOGIN_BANNER_URL } from "./config/staticAssets";
import { cleanupLegacyServiceWorkers } from "./utility/cacheCleanup";

const initThemeFromStorage = () => {
  const isDark = localStorage.getItem("isDark") === "true";
  const theme = isDark ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", theme);
  document.documentElement.setAttribute("data-bs-theme", theme);
  document.body.classList.toggle("darkMode", isDark);
  document.body.classList.toggle("lightMode", !isDark);
};

initThemeFromStorage();

if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

document.documentElement.style.setProperty(
  "--wlj-login-banner-image",
  `url("${LOGIN_BANNER_URL}")`
);

cleanupLegacyServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <GoogleOAuthProvider clientId="1083740285274-tvvsachfqqlh5o9818f77dh55kko0nvs.apps.googleusercontent.com">
      <App />
      <AppPortalHost />
    </GoogleOAuthProvider>
  </ErrorBoundary>
);
document.addEventListener("DOMContentLoaded", function () {
  const isDark = localStorage.getItem("isDark");
  if (isDark) {
    document.body.style.backgroundColor = "#1a1a1e";
  } else {
    document.body.style.backgroundColor = "#F2F2F2";
  }
});

reportWebVitals();
